import { CommonModule } from '@angular/common';
import { Component, computed, effect, EventEmitter, HostListener, inject, Input, Output, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Dialog, DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { Assembly } from 'src/app/models/assembly.model';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { CatalogAssembly } from 'src/app/models/catalog-assembly';
import { Category } from 'src/app/models/category.model';
import { BinderAssembliesService } from 'src/app/services/app/binder-assemblies.service';
import { ListboxModule } from 'primeng/listbox';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CustomAssemblyComponent } from './custom-assembly/custom-assembly.component';
import { CatalogService } from '@/services/api/catalog.service';
import { BinderService } from '@/services/api/binder.service';
import { CategoriesService } from '@/services/api/categories.service';
import { AssembliesService } from '@/services/api/assemblies.service';
import { AppStateService } from '@/services/app/app-state.service';
import { LearningAssembliesService } from '@/services/data/learning/learning-assemblies';
import { AssemblyFinderService } from '@/services/app/assembly-finder.service';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { UserAccessService } from '@/services/app/user-access.service';
import { DrawerModule } from 'primeng/drawer';
import { BreakpointService } from '@/layout/service/breakpoint.service';
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenubarModule } from 'primeng/menubar';

@Component({
    selector: 'app-landmark-assembly-picker',
    template: `
        <!-- Root layout -->
        <div class="h-full w-full flex flex-col overflow-hidden">

<!-- Top Menubar -->
<p-toolbar class="shadow-sm">

  <ng-template #start>
    <button
      pButton
      type="button"
      class="p-button-text"
      [icon]="hamburgerIcon()"
      (click)="toggleMenu()"
      aria-label="Toggle menu">
    </button>
  </ng-template>
  <ng-template #center>
  <p-selectButton [options]="assemblyTypes" optionLabel="label" [(ngModel)]="selectedAssemblyType" optionValue="value" (onChange)="toggleAssemblies($event.value)"></p-selectButton>
  </ng-template>
  <ng-template #end>
    <!-- Right-side actions -->
    <button pButton icon="pi pi-plus" label="Custom" class="p-button-primary mr-2" (click)="showCustom()"></button>
  </ng-template>
</p-toolbar>

<!-- Content area -->
<div class="flex-1 min-h-0 flex">

  <!-- ====== LARGE SCREENS (lg and up): inline left menu ====== -->
  <ng-container *ngIf="bp.isLgUp()">
    <aside
      *ngIf="sideOpen()"
      class="w-64 border-r bg-surface-0/50 dark:bg-surface-900/30 min-h-0 overflow-auto">
      <p-panelMenu
        [model]="sideNav()"
        [style]="{ 'border': 'none' }"
        (itemClick)="onNavigate()">
      </p-panelMenu>
    </aside>
  </ng-container>

  <!-- Main content -->
  <main class="flex-1 min-w-0 min-h-0 overflow-auto p-4">
  <app-custom-assembly (assemblySaved)="onAssemblySaved($event)" (cancelled)="customVisible = false" [class.hidden]="!customVisible"></app-custom-assembly>
  <p-table [class.hidden]="customVisible" [value]="displayedAssemblies" sortField="Categories" sortMode="single" [scrollable]="true" rowGroupMode="subheader" groupRowsBy="Categories.CategoryID" >
                    <ng-template pTemplate="groupheader" let-assembly>
                        <tr pRowGroupHeader id="category-{{assembly.Categories.CategoryID}}" class="assembly-group-header">
                            <td colspan="2">
                                <span class="text-2xl font-bold text-900 mb-0">{{assembly.Categories.Name}}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-assembly let-rowIndex="rowIndex">
                        <tr *ngIf="!assembly.isDummy; else noItems" [pSelectableRow]="assembly" id="assembly-{{assembly.AID}}" [pSelectableRowIndex]="rowIndex" [style]="{'background-color': isInBinder(assembly) ? '#e6f7ff' : ''}">
                            <td >
                                <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                                    <div class="flex flex-column align-items-center sm:align-items-start gap-4">
                                        <!-- <div *ngIf="assembly.Name" class="font-bold">{{ assembly.Name }}</div> -->
                                        <p>{{ assembly.Description }}</p>
                                    </div>
                            </div>
                    </td>
                    <td>
                        <div class="flex flex-column align-items-end gap-3">
                                    <p-inputgroup *ngIf="displayedAssemblies !== standards">
                                        <p-inputgroup-addon>
                                            <span>{{ assembly.price | currency }} X </span>
                                        </p-inputgroup-addon>
                                        <p-inputNumber *ngIf="displayedAssemblies !== standards" [(ngModel)]="assembly.quantity" placeholder="Quantity" (onInput)="calculateTotal(assembly,$event)" type="number" [min]="0">
                                        </p-inputNumber>
                                        <p-inputgroup-addon>
                                        <span *ngIf="displayedAssemblies !== standards" class="p-inputgroup-addon">= {{ assembly.total | currency }}</span>  
                                    </p-inputgroup-addon>
                                        <button type="button" pButton [icon]="isInBinder(assembly) ? 'pi pi-sync' : 'pi pi-plus'" class="p-button-primary" (click)="addAssembly(assembly)" [disabled]="isDisabled(assembly)"></button>
                                    </p-inputgroup>
                                    <button *ngIf="displayedAssemblies === standards && !isInBinder(assembly)" type="button" pButton icon="pi pi-plus" class="p-button-primary" (click)="addAssembly(assembly)" [disabled]="isDisabled(assembly)"></button>
                                    <button *ngIf="displayedAssemblies === standards && isInBinder(assembly)" type="button" pButton icon="pi pi-check" class="p-button-primary"  [disabled]="true"></button>
                            
                        </div>
                    </td>
                          </tr>
                          <ng-template #noItems>
                            <tr>
                                <td>
                                    <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                                        <div class="flex flex-column align-items-center sm:align-items-start gap-4">
                                            <div class="font-bold">No items found</div>
                                        </div>
                                </div>
                            </td>
                            <td>
                            <div class="flex flex-column align-items-end gap-3" *ngIf="checkCustom(assembly.Categories)">
                                <div class="font-semibold">
                                    <button pButton icon="pi pi-plus" label="Add Custom" class="p-button-primary mr-2" (click)="showCustom(assembly.Categories)"></button>
                                </div>
                            </div>
                            </td>
                              </tr>
                          </ng-template>
                    </ng-template>
                </p-table>
  </main>
</div>

<!-- ====== SMALL/MEDIUM SCREENS: overlay menu ====== -->
<p-sidebar
  position="left"
  [fullScreen]="true"
  [modal]="true"
  [dismissible]="true"
  [blockScroll]="true"
  [(visible)]="overlayOpen"
  (onHide)="overlayOpen = false"
  styleClass="!p-0">
  <div class="h-full flex flex-col">
    <div class="p-3 border-b flex items-center justify-between">
      <span class="font-semibold">Menu</span>
      <button pButton type="button" class="p-button-text" icon="pi pi-times" (click)="overlayOpen = false"></button>
    </div>
    <div class="flex-1 min-h-0 overflow-auto">
      <p-panelMenu
        [model]="sideNav()"
        [style]="{ 'border': 'none' }"
        (itemClick)="onNavigate()">
      </p-panelMenu>
    </div>
  </div>
</p-sidebar>
</div>
    `,
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        InputNumberModule,
        ButtonModule,
        SkeletonModule,
        AccordionModule,
        DialogModule,
        ToggleSwitchModule,
        ListboxModule,
        ToolbarModule,
        ToastModule,
        SelectButtonModule,
        TableModule,
        SidebarModule, 
        PanelMenuModule,
        CustomAssemblyComponent,
        MenubarModule,
        InputGroupModule,
        InputGroupAddonModule,
        DrawerModule
    ]
})
export class AssemblyPickerComponent {

  private binderAssembliesService = inject(BinderAssembliesService);
  private catalogService = inject(CatalogService);
  private currentBinderService = inject(BinderService);
  private learningCatalogService = inject(LearningAssembliesService);
  private assembliesService = inject(AssembliesService);
  private appStateService = inject(AppStateService);
  private messageService = inject(MessageService);
  categoriesService = inject(CategoriesService);
  userAccessService = inject(UserAccessService);
  bp = inject(BreakpointService);

  @ViewChild(Dialog) dialog!: Dialog;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateDialogSize();
  }

  optionsFID!: number;
  planId!: number;
  ssid!: number;
  binderAssemblies: BinderAssembly[] = [];
  binderId = 0;
  categories: Category[] = [];
  assemblies: CatalogAssembly[] = [];
  options: CatalogAssembly[] = [];
  standards: CatalogAssembly[] = [];
  displayedAssemblies = this.assemblies;
  learningMode = false;

  tempQuantities: { [key: number]: number } = {};

  formGroup!: FormGroup;
  selectedAssemblyType = 'O';
  selectedCategory = signal<Category | null>(null);
  selectedSortOption: SelectItem = { label: 'Name (A-Z)', value: 'Name' };

  sortOptions!: SelectItem[];
  customVisible = false;

  visible = false;
  
  sortOrder!: number;
  sortField!: string;
  dummyAssembly = {
    Name: "",
    Description: "",
    Type: "O",
    AID: 0,
    isDummy: true,
    AssemblyPriceTable: [{
      PlanID: 0,
      Price: 0,
      AID: 0,
      APID: 0,
      Type: false,
      FID: 0
    }],
    AssemblyPrice: 0
  }

  assemblyTypes: any[] = [
    { label: 'Options', value: 'O' },
    { label: 'Standards', value: 'S' }
  ];

   // State
   sideOpen = signal(true);              // inline sidebar (lg+) visible?
   overlayOpen = false;                  // small-screen overlay visible?
   isOverlay = computed(() => !this.bp.isLgUp());
   hamburgerIcon = computed(() => this.isOverlay() ? 'pi pi-bars' : (this.sideOpen() ? 'pi pi-chevron-left' : 'pi pi-bars'));

    // Top bar menu (example)
  topMenu: MenuItem[] = [
    { label: 'Home', icon: 'pi pi-home', command: () => this.navigate('/home') },
    { label: 'Settings', icon: 'pi pi-cog', command: () => this.navigate('/settings') },
  ];

  // Side nav (example)
  sideNav = computed<MenuItem[]>(() =>
    this.mapCategoriesToMenuItems(
      this.userAccessService.foundersCategories(),
      this.selectedCategory()?.CategoryID ?? null,
      (cat) => this.selectCategory(cat),
    )
  );

  constructor(
  ) { 
    effect(() => {
      const category = this.selectedCategory();
      if(category) {
        this.selectCategory(category);
      }
      if(this.catalogService.selectedAssembly()) {
        this.showDialog();
        this.scrollToAssembly(this.catalogService.selectedAssembly());
      }
      this.categories = this.categoriesService.categories();
      this.learningMode = this.appStateService.learningMode();
      if (this.currentBinderService.currentBinder()) {
        this.binderId = this.currentBinderService.currentBinder().BinderID;
        this.binderAssemblies = this.currentBinderService.currentBinder()?.BinderAssemblies || [];
        this.ssid = this.currentBinderService.currentBinder()?.SSID || 0;
        this.planId = this.currentBinderService.currentBinder()?.PlanID || 0;
        this.optionsFID = this.currentBinderService.currentBinder()?.Franchises_Binders_SelectedFIDToFranchises.Options_FID ?? this.currentBinderService.currentBinder()?.Franchises_Binders_SelectedFIDToFranchises.FID ?? 0;
        if (this.categories.length > 0 && this.planId > 0 && this.optionsFID > 0) {
          this.sortAssemblies(this.planId, this.optionsFID, this.ssid);
        }
      }
    });
    effect(() => {
      if (this.isOverlay()) {
        // moving to small screen mode: close inline, ensure overlay closed until user opens it
        this.sideOpen.set(false);
        this.overlayOpen = false;
      } else {
        // moving to large screen mode: close overlay, default to showing inline side menu
        this.overlayOpen = false;
        this.sideOpen.set(true);
      }
    });

    this.sortOptions = [
      { label: 'Name (A-Z)', value: 'Name' },
      { label: 'Name (Z-A)', value: '!Name' },
      { label: 'Price High to Low', value: '!assemblyPrice' },
      { label: 'Price Low to High', value: 'assemblyPrice' }
    ];
  }

  mapCategoriesToMenuItems(
    cats: Category[],
    selectedId: number | null,
    onPick: (cat: Category) => void,
  ): MenuItem[] {
    const toItem = (c: Category): MenuItem => {
      const isActive = c.CategoryID === selectedId;
      const base: MenuItem = {
        label: c.Name,
        // icon: 'pi pi-list',
        // `data` can carry the category back on click
        data: { category: c },
        // Mild highlighting for the selected category
        styleClass: isActive ? 'bg-primary-50 dark:bg-primary-900/30 font-semibold' : '',
        command: () => onPick(c),
      };
  
      return base;
    };
  
    return cats.map(toItem);
  }

  updateDialogSize() {
    // if (window.innerWidth <= 660 && !this.dialog.maximized) {
    //   this.dialog.maximize();
    //   this.triggerResize();
    // } else if (window.innerWidth > 660 && this.dialog.maximized) {
    //   this.dialog.maximize();
    //   this.triggerResize();
    // }
  }

  triggerResize() {
    this.dialog.headerViewChild?.nativeElement.dispatchEvent(
      new MouseEvent('mousedown')
    );
    window.dispatchEvent(new MouseEvent('mouseup'));
  }

  showDialog() {
    this.visible = true;
  }

  get category() {
    return this.selectedCategory();
  }

  set category(category: Category | null) {
    this.selectedCategory.set(category);
  }

  showCustom(category?: Category) {
    this.customVisible = true;
    if (category) {
      this.categoriesService.setSelectedCategoryById(category.CategoryID);
    }
  }

  toggleAssemblies(type: string) {
    this.selectedAssemblyType = type;
    if (type === 'S') {
      this.displayedAssemblies = this.standards;
    } else if (type === 'O') {
      this.displayedAssemblies = this.options;
    }
  }

  // Method to check if the assembly is in binderAssemblies and if standards are being displayed
  isDisabled(assembly: Assembly): boolean {
    return this.displayedAssemblies === this.standards && this.binderAssembliesService.binderAssemblies().some(binderAssembly => binderAssembly.AID === assembly.AID);
  }

  scrollToAssembly(assembly: CatalogAssembly|null) {
    if(!assembly) return;
    const tryScroll = () => {
      if (assembly.Type) {
        this.toggleAssemblies(assembly.Type);
      }
      const categoryElement = document.getElementById(`category-${assembly.CategoryID}`);
      const assemblyElement = document.getElementById(`assembly-${assembly.AID}`);

      if (categoryElement && assemblyElement && categoryElement.offsetParent !== null) {
        categoryElement.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => assemblyElement.scrollIntoView({ behavior: 'smooth' }), 500);
      } else {
        setTimeout(tryScroll, 100); // Retry after 100ms
      }
    };

    tryScroll();
  }

  isInBinder(assembly: CatalogAssembly): boolean {
    return this.binderAssembliesService.binderAssemblies().some(binderAssembly => binderAssembly.AID === assembly.AID);
  }

  setAssemblies(assemblies: Assembly[],planId: number){
    const noAssemblies: string[] = [];
    this.assemblies = assemblies.map(assembly => {
      const priceRecord = assembly.AssemblyPriceTable.find(price => price.PlanID === planId)
        || assembly.AssemblyPriceTable.find(price => price.PlanID === 1);
      if (!priceRecord) {
        if (assembly.Type === 'O') {
          console.log(`No price record found for assembly with ID: ${assembly.AID}`);
          return null;
        }
        else {
          return assembly
        }
      }


      // Find the matching assembly in binderAssemblies
      let binderAssembly = this.binderAssemblies.find(binderAssembly => binderAssembly.AID === assembly.AID);

      // Set the quantity to the matching quantity in binderAssemblies if it exists, otherwise set it to 0
      let quantity = binderAssembly ? binderAssembly.Quantity : null;

      let total = priceRecord.Price;

      // Calculate the total
      if (quantity !== null) {
        let total = quantity * priceRecord.Price;
      }

      return { ...assembly, price: priceRecord.Price, quantity: quantity, total: total };
    }).filter(assembly => assembly !== null) as Assembly[];

    this.catalogService.setAssemblies(this.assemblies);

    this.options = this.assemblies.filter(assembly => assembly.Type !== 'S');
    this.standards = this.assemblies.filter(assembly => assembly.Type === 'S');
    this.displayedAssemblies = this.options;

    // Iterate over all categories
    this.categories.forEach(category => {
      // Check if there are any assemblies for this category
      const hasAssemblies = this.assemblies.filter(assembly => assembly.CategoryID === category.CategoryID);
      // If there are no assemblies, create a dummy
      if (!hasAssemblies || hasAssemblies.length === 0) {
        noAssemblies.push(category.Name);
        this.displayedAssemblies.push({
          ...this.dummyAssembly, CategoryID: category.CategoryID, Categories: category, FID: this.optionsFID
        });
      }
    });
    if(noAssemblies.length > 0) {
      console.log(`no assemblies for ${noAssemblies.length} categories`);
    }
  }

  checkCustom(category: Category) {
    return this.currentBinderService.currentBinder().Plans.Collection === 'Founders' && category.CategoryID === 322 || this.currentBinderService.currentBinder().Plans.Collection !== 'Founders';
  }

  sortAssemblies(planId: number, optionsFID: number, ssid: number) {
    if (planId > 0 && optionsFID > 0) {
      if(this.learningMode){
        this.learningCatalogService.loadAssemblies().subscribe(assemblies => {
          this.setAssemblies(assemblies,planId) 
        }, error => {
          console.error('Error fetching assemblies: ', error);
        });
      } else if(this.currentBinderService.currentBinder().Plans.Collection === 'Founders'){
        this.assembliesService.getFoundersCatalog(optionsFID, planId).subscribe(assemblies => {
          this.setAssemblies(assemblies,planId)
        }, error => {
          console.error('Error fetching categories: ', error);
        });
      } else {
        this.assembliesService.getCatalog(optionsFID, planId, ssid).subscribe(assemblies => {
          this.setAssemblies(assemblies,planId)
        }, error => {
          console.error('Error fetching categories: ', error);
        });
      }
      
    }
    else {
      console.log(`catalog failed. current values for fetching: FID: ${optionsFID} PlanID: ${planId}`)
    }
  }

  getHighestBAID(): number {
    const assemblies = this.binderAssemblies;
    if (assemblies.length === 0) return 0;
    
    return Math.max(...assemblies.map(assembly => assembly.BAID));
  }
  
  createAssembly(assembly: CatalogAssembly) {
    const sameCategoryAssemblies = this.binderAssemblies.filter(binderAssembly => binderAssembly.CategoryID === assembly.CategoryID);
    const maxPrintOrder = Math.max(...sameCategoryAssemblies.map(a => a.PrintOrder), 0);
    if(this.learningMode) {
      const newAssembly = {
        Name: assembly.Name,
        BAID: this.getHighestBAID() + 1,
        CategoryID: assembly.CategoryID,
        Description: assembly.Description,
        Price: assembly.price,
        Quantity: assembly.quantity,
        Type: assembly.Type,
        AID: assembly.AID,
        BinderID: this.binderId,
        PrintOrder: maxPrintOrder + 1
      }
      this.binderAssembliesService.addAssemblyLocally(newAssembly);
    } else {
      const newData = {
        Name: assembly.Name,
        Categories: {
        connect: {
          CategoryID: assembly.CategoryID
        }
      },
      Description: assembly.Description,
      Price: assembly.price,
      Quantity: assembly.quantity,
      Type: assembly.Type,
      AID: assembly.AID,
      Binders: {
        connect: {
          BinderID: this.binderId
        }
      },
      PrintOrder: maxPrintOrder + 1,
    }
    this.binderAssembliesService.addAssembly(newData).subscribe({
      next: (updated) => {
        console.log('assembly updated', updated);
        this.customVisible = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly added', life: 3000 });
      },
      error: (error) => {
        console.error('Error updating assembly:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error adding assembly', life: 3000 });
      }
    });
    }
  }

  onAssemblySaved(assembly: any) {
    const sameCategoryAssemblies = this.binderAssemblies.filter(binderAssembly => binderAssembly.CategoryID === assembly.CategoryID);
    const maxPrintOrder = Math.max(...sameCategoryAssemblies.map(a => a.PrintOrder), 0);
    if(this.learningMode) {
      const newAssembly = {
        Name: assembly.Name,
        BAID: this.getHighestBAID() + 1,
        CategoryID: assembly.CategoryID,
        Description: assembly.Description,
        Price: assembly.price,
        Quantity: assembly.quantity,
        Type: assembly.Type,
        AID: assembly.AID,
        BinderID: this.binderId,
        PrintOrder: maxPrintOrder + 1
      }
      this.binderAssembliesService.addAssemblyLocally(newAssembly);
    } else {
      const newData = {
        Name: assembly.Name,
        Categories: {
        connect: {
          CategoryID: assembly.CategoryID
        }
      },
      Description: assembly.Description,
      Price: assembly.price,
      Quantity: assembly.quantity,
      Type: assembly.Type,
      Binders: {
        connect: {
          BinderID: this.binderId
        }
      },
      PrintOrder: maxPrintOrder + 1,
    }
    this.binderAssembliesService.addAssembly(newData).subscribe({
      next: (updated) => {
        console.log('assembly updated', updated);
        this.customVisible = false;
      },
      error: (error) => {
        console.error('Error updating assembly:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error adding assembly', life: 3000 });
      }
    });
  }
  }

  updateAssembly(originalAssembly: BinderAssembly, quantity: number) {
    const updateData = {
      Quantity: quantity
    }
    this.binderAssembliesService.updateAssembly(originalAssembly.BAID, updateData).subscribe({
      next: (updated) => {
        console.log('assembly updated', updated);
      },
      error: (error) => {
        console.error('Error updating assembly:', error);
      }
    });
  }

  onSortChange(event: any) {
    let value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }

  selectCategory(category: Category) {
    this.categoriesService.setSelectedCategoryById(category.CategoryID);
    const element = document.getElementById('category-' + category.CategoryID.toString());
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  calculateTotal(assembly: CatalogAssembly, event: any) {
    let quantity = event.value;
    if (assembly.price && !isNaN(assembly.price)) {
      let total = (quantity === null || quantity === '' ? 1 : quantity) * assembly.price;
      let index = this.assemblies.findIndex(a => a.AID === assembly.AID);
      if (index !== -1) {
        this.assemblies[index].total = total;
        this.assemblies[index].quantity = quantity;
      }
    } else {
      console.log('Price is undefined');
    }
  }

  addAssembly(assembly: CatalogAssembly) {
    console.log('adding!')
    let binderAssembly = this.binderAssemblies.find(binderAssembly => binderAssembly.AID === assembly.AID);
    if (binderAssembly) {
      this.updateAssembly(binderAssembly, assembly.quantity || 0);
    } else {
      this.createAssembly(assembly);
    }
  }


  toggleMenu() {
    if (this.isOverlay()) {
      this.overlayOpen = !this.overlayOpen;
    } else {
      this.sideOpen.update(v => !v);
    }
  }

  onNavigate() {
    // Behavior requested:
    // - Small screens: clicking an item hides the menu completely (overlay)
    // - Large screens: leave inline menu as-is
    if (this.isOverlay()) {
      this.overlayOpen = false;
    }
    // ... put any route navigation here if needed
  }

  private navigate(path: string) {
    // plug in Angular Router navigation here if desired
    // this.router.navigateByUrl(path);
    this.onNavigate();
  }


}
